module.exports = __webpack_public_path__ + "img/grey.2e90c1b.svg";